import { InsuranceCompany, InsuranceCompanyEnum } from '../model/InsuranceCompany';

export const insuranceCompanies: InsuranceCompany[] = [
  {
    name: 'VZP',
    csFullName: 'Všeobecná zdravotní pojišťovna',
    code: InsuranceCompanyEnum.Vzp,
    numericCode: 111
  },
  {
    name: 'VOZP',
    csFullName: 'Vojenská zdravotní pojišťovna',
    code: InsuranceCompanyEnum.Vozp,
    numericCode: 201
  },
  {
    name: 'CPZP',
    csFullName: 'Česká průmyslová zdravotní pojišťovna',
    code: InsuranceCompanyEnum.Cpzp,
    numericCode: 205
  },
  {
    name: 'OZP',
    csFullName: 'Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví',
    code: InsuranceCompanyEnum.Ozp,
    numericCode: 207
  },
  {
    name: 'ZPS',
    csFullName: 'Zaměstnanecká pojišťovna Škoda',
    code: InsuranceCompanyEnum.Zps,
    numericCode: 209
  },
  {
    name: 'ZPMV',
    csFullName: 'Zdravotní pojišťovna ministerstva vnitra',
    code: InsuranceCompanyEnum.Zpmv,
    numericCode: 211
  },
  {
    name: 'RBP',
    csFullName: 'Revírní bratrská pokladna, zdravotní pojišťovna',
    code: InsuranceCompanyEnum.Rbp,
    numericCode: 213
  },
  {
    name: 'OTHER',
    csFullName: 'Jiná',
    code: InsuranceCompanyEnum.Other,
    numericCode: -1
  }
];

